import actionTypes from './ActionTypes';
import actionTypesAuth from '../Auth/ActionTypes';
import apiSettings from '../../config/api';
import request from '../../utils/request';
import {validateEditProfile} from '../../utils/validationUtils';

const handleChange = (e) => {
  return dispatch => {
    dispatch({type: actionTypes.CHANGED_INPUT_DATA, data: {field: e.target.name, value: e.target.value}})
  }
};

const editProfile = () => {
  return (dispatch, getState) => {
    const state = getState();
    const {dataForEdit} = state.profile;
    const validation = validateEditProfile(dataForEdit);
    if (validation.isValid) {
      const data = {
        name: dataForEdit.name,
        lastName: dataForEdit.lastName,
        phone: dataForEdit.phone,
        companyName: dataForEdit.companyName,
        sendEmailNotifications: dataForEdit.sendEmailNotifications
      };
      const url = apiSettings.endpoints.genEditUserInfoUrl();
      request
        .post(url, data, dispatch, actionTypes.EDIT_PROFILE)
        .then((res) => {
          dispatch({type: actionTypesAuth.GET_USER_INFO.fulfilled, data: res.data});
          dispatch({type: actionTypes.EDIT_PROFILE.fulfilled})
          setTimeout(() => {
            dispatch({type: actionTypes.OFF_SUCCESS_UPDATE})
          }, 2000)
        })
    } else {
      dispatch({type: actionTypes.EDIT_PROFILE.rejected, data: validation.error})
    }
  }
};

const toggleShowChangeEmailModal = () => {
  return dispatch => {
    dispatch({type: actionTypes.TOGGLE_IS_SHOW_CHANGE_EMAIL_MODAL})
  }
};

const changeUserEmail = (data) => {
  return dispatch => {
    const url = apiSettings.endpoints.genEditUserEmailUrl();
    request
      .post(url, data, dispatch, actionTypes.EDIT_USER_EMAIL)
      .then((res) => {
        dispatch({type: actionTypes.EDIT_USER_EMAIL.fulfilled});
        dispatch({type: actionTypes.GET_USER_DATA_FOR_EDIT, data: res.data});
        dispatch({type: actionTypesAuth.GET_USER_INFO.fulfilled, data: res.data});
      })
  }
};


const toggleShowChangePasswordModal = () => {
  return dispatch => {
    dispatch({type: actionTypes.TOGGLE_IS_SHOW_CHANGE_PASSWORD_MODAL})
  }
};

const changeUserPassword = (data) => {
  return dispatch => {
    const url = apiSettings.endpoints.genEditUserPasswordUrl();
    request
      .post(url, data, dispatch, actionTypes.EDIT_USER_PASSWORD)
      .then(() => {
        dispatch({type: actionTypes.EDIT_USER_PASSWORD.fulfilled});
      })
  }
};


const toggleShowDeleteAccountModal = () => {
  return dispatch => {
    dispatch({type: actionTypes.TOGGLE_IS_SHOW_DELETE_USER_ACCOUNT})
  }
};

const deleteAccount = (data) => {
  return dispatch => {
    const url = apiSettings.endpoints.genDeleteUserAccountUrl();
    request
      .post(url, data, dispatch, actionTypes.DELETE_USER_ACCOUNT)
      .then(() => {
        dispatch({type: actionTypes.DELETE_USER_ACCOUNT.fulfilled});
        dispatch({type: actionTypesAuth.LOGOUT.fulfilled})
      })
  }
};

export {
  handleChange,
  editProfile,
  toggleShowChangeEmailModal,
  changeUserEmail,
  toggleShowChangePasswordModal,
  changeUserPassword,
  toggleShowDeleteAccountModal,
  deleteAccount
}


// WEBPACK FOOTER //
// ./src/app/containers/Profile/Actions.js